import RESOURCE_CATEGORY_DISPLAY_NAMES from '../constants/resourceCategoryDisplayNames';
import moment from 'moment';
import { v4 as uuid } from 'uuid';

const ONE_MONTH = 1;

const ResourcesMapper = {
  toResourcesData: resources => {
    const oneMonthAgo = moment().subtract(ONE_MONTH, 'month');

    return resources.map(resource => {
      const category = RESOURCE_CATEGORY_DISPLAY_NAMES[resource.Category];
      return {
        tab: category.name,
        tabName: category.value,
        ...mapResource(resource, oneMonthAgo)
      };
    });
  },

  newResourceToResourceData: newResource => {
    const category = RESOURCE_CATEGORY_DISPLAY_NAMES[newResource.category];

    return {
      ...newResource,
      resourceId: uuid(),
      tab: category.name,
      tabName: category.value,
      hasReleaseIcon: true,
      isNewResource: true
    };
  },

  toResourcesInput: resource => ({
    Id: resource.isNewResource ? undefined : resource.resourceId,
    Category: resource.category,
    Title: resource.title,
    Link: resource.link,
    Description: resource.description,
    ResourcePermissions: resource.permissions
  }),

  mapResourcePermissions: resource => ({
    ...resource,
    permissions: resource.permissions.map(permission => permission.value)
  })
};
export default ResourcesMapper;

const mapResource = (resource, referenceDate = moment().subtract(1, 'month')) => ({
  resourceId: resource.Id,
  title: resource.Title,
  link: resource.Link,
  description: resource.Description,
  hasReleaseIcon: moment(resource.CreatedDate).isSameOrAfter(referenceDate),
  permissions: resource.ResourcePermissions,
  category: resource.Category
});
